export default __webpack_public_path__ + "static/media/zertiassist_iconos_calendar_24px.451edf65.svg";